import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const chatWithFeedbackFeatureFlag: FeatureFlagType = {
  name: 'chat-with-feedback',
  fallback: false,
};

export const useIsChatWithFeedbackEnabled = () => {
  const [, isEnabled] = useFeatureFlag(chatWithFeedbackFeatureFlag);

  return isEnabled;
};
